import { ReactNode } from "react";
import { Modal, ModalProps } from "react-bootstrap";

interface LegalDocumentModalProps extends ModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  children: ReactNode;
}

const LegalDocumentModal = ({
  show,
  onHide,
  title,
  children,
  ...props
}: LegalDocumentModalProps) => {
  return (
    <Modal
      {...props}
      show={show}
      onHide={onHide}
      backdrop="static"
      backdropClassName="legalDocumentModalBackdrop"
      className="mosidaModal legalDocumentModal"
      keyboard={false}
      centered
      scrollable
      size="lg"
      enforceFocus={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <button type="button" className="btnPrimary w-100 sqaure" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LegalDocumentModal;
